import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api, { logout } from '@/api'

type UserSettings = {
  recipeLanguage: string
}
type MeResponse = {
  id: string
  email: string
  name: string
  creditBalance: number
  settings: UserSettings | null
}

export const useMeQuery = () => {
  return useQuery<MeResponse>({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try {
        const res = await api.get<MeResponse>('/auth/me')
        return res.data
      } catch (error) {
        logout()
        throw error
      }
    },
    staleTime: 1000 * 60 * 5,
    retry: false,
  })
}

export const usePatchUserSettingsMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (settings: Partial<UserSettings>) => {
      const response = await api.patch('/auth/settings', settings)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth', 'me'] })
    },
  })
}
